import { ChannelsApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useChannelsAPI(): ChannelsApi {
  return new ChannelsApi(apiConfig);
}
